import { schema } from "normalizr";
import { typesTypes } from "../types";
import Resource from "./resource";
import {client} from "../store";

const typesSchema = new schema.Entity("types");

export default new Resource("/kinds", typesTypes, typesSchema);

client.enableAutoCamelCase('/kinds');